import { useEffect, useRef } from 'react';
import { useIsForegroundNow } from './useIsForegroundNow';

type UseForegroundIntervalOptions = {
  /** 포그라운드 복귀 시 즉시 1회 실행 여부 (default: true) */
  immediate?: boolean;
};

/**
 * Activity 포커스 + OS 포그라운드 상태일 때만 동작하는 setInterval.
 * - delay가 null이면 비활성화 (interval 정지), 기본값 1000ms
 * - immediate: true(기본값)이면 포그라운드 복귀 시 즉시 1회 실행
 */
export const useForegroundInterval = (
  callback: () => void,
  delay: number | null = 1000,
  options?: UseForegroundIntervalOptions,
) => {
  const callbackRef = useRef(callback);
  callbackRef.current = callback;

  const immediate = options?.immediate ?? true;

  const isForeground = useIsForegroundNow();

  useEffect(() => {
    if (delay === null || !isForeground) return;

    if (immediate) {
      callbackRef.current();
    }

    // eslint-disable-next-line no-restricted-globals -- 이 훅이 setInterval의 유일한 허용 래퍼
    const id = setInterval(() => callbackRef.current(), delay);
    return () => clearInterval(id);
  }, [delay, isForeground, immediate]);
};
